module.exports = __webpack_public_path__ + "img/Software.5e0ded36.png";